<script>
    // Import settings
    export let social;
</script>

<div class="container mx-auto py-5 flex max-h-48 w-48">
    {#each social as item}
        <a href="{item.link}" target="_blank" rel="noreferrer" class="flex-auto text-zinc-900 hover:text-zinc-500 px-3 pb-4 md:basis-2/12">{@html item.icon}</a>
    {/each}
</div>